import React, { useEffect, useState, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { UI_CONSTANTS } from "../../utils/constants";

const getMediaUrl = (path) => {
  if (!path || typeof path !== "string") return null;
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const base = (process.env.REACT_APP_API || "http://quytech.in:5001").replace(/\/+$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

function SoundTrack() {
  const [fetching, setFetching] = useState(true);
  const [loading, setLoading] = useState(false);
  const [existingTrack, setExistingTrack] = useState(null);
  const [audioPreview, setAudioPreview] = useState(null);
  const [file, setFile] = useState(null);

  const fetchSoundTrack = useCallback(async () => {
    setFetching(true);
    try {
      const response = await handleApiCall("get", endpoints.getSoundTrack);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const payload = response?.data?.data || response?.data;
        const track = payload?.sound_track || payload?.soundTrack || payload?.url || payload?.file || "";
        const resolved = getMediaUrl(track);
        setExistingTrack(track);
        setAudioPreview(resolved);
      } else if (response?.error) {
        console.error("Error fetching sound track:", response?.message);
      }
    } catch (error) {
      console.error("Error fetching sound track:", error);
      toast.error("Failed to fetch sound track");
    } finally {
      setFetching(false);
    }
  }, []);

  useEffect(() => {
    fetchSoundTrack();
  }, [fetchSoundTrack]);

  const handleAudioChange = (e) => {
    const selected = e.target.files[0];
    if (selected) {
      if (!selected.type.startsWith("audio/")) {
        toast.error("Please select a valid audio file");
        return;
      }
      // const maxSize = 20 * 1024 * 1024; // 20MB
      const maxSize = 45 * 1024 * 1024; // 45MB
      if (selected.size > maxSize) {
        toast.error("Audio file size should not exceed 45MB");
        return;
      }
      setFile(selected);
      const reader = new FileReader();
      reader.onload = (event) => setAudioPreview(event.target.result);
      reader.readAsDataURL(selected);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select an audio file to upload");
      return;
    }

    try {
      setLoading(true);
      const submitData = new FormData();
      submitData.append("sound_track", file);
      const response = await handleApiCall("put", endpoints.updateSoundTrack, submitData);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Sound track updated successfully!");
        setFile(null);
        fetchSoundTrack();
      } else if (response?.error) {
        console.error("Error updating sound track:", response?.message);
      }
    } catch (error) {
      console.error("Error updating sound track:", error);
      toast.error("Failed to update sound track");
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
              <div className="spinner-border" role="status">
                <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Sound Track</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? UI_CONSTANTS.BUTTON_LABELS.UPDATING : UI_CONSTANTS.BUTTON_LABELS.UPDATE}
                    </Button>
                  </div>
                </div>
                <div className="row mx-n2">
                  <div className="form-group col-md-12 px-2">
                    <label className="text-white mb-2">Current Sound Track</label>
                    {audioPreview ? (
                      <div className="d-flex align-items-center gap-3">
                        <i className="mdi mdi-music-circle text-white mr-3" style={{ fontSize: "32px" }} />
                        <audio controls src={audioPreview} style={{ width: "100%" }}>
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    ) : (
                      <div className="text-muted d-flex align-items-center">
                        <i className="mdi mdi-music-off mr-2" />
                        No sound track available. Please upload one below.
                      </div>
                    )}
                  </div>
                </div>
                <div className="row mx-n2 mt-4">
                  <div className="form-group col-md-12 px-2">
                    <label className="text-white mb-2">Upload New Sound Track</label>
                    <input type="file" accept="audio/*" className="form-control default" onChange={handleAudioChange} />
                    <small className="text-muted d-block mt-1">Supported formats: audio files up to 45MB.</small>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SoundTrack;

